
import {
  computed, defineComponent,
} from 'vue';

export default defineComponent({
  name: 'SelecionarBoolean',
  components: {
  },
  props: {
    valor: {
      type: Boolean,
    },
    descricaoTrue: {
      type: String,
      required: true,
    },
    descricaoFalse: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    radioButton: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:valor', 'change'],
  setup(props, { emit }) {
    const computedValor = computed({
      get: () => props.valor,
      set: (valor: boolean) => {
        emit('update:valor', valor);
      },
    });

    function defineValorSelecionado(valor:boolean) {
      emit('update:valor', valor);
      emit('change', valor);
    }

    function defineValorMarcado(valor:boolean) {
      emit('change', valor);
    }

    return {
      props,
      computedValor,
      defineValorSelecionado,
      defineValorMarcado,
    };
  },
});
